export default __webpack_public_path__ + "static/media/dashboard.05f45001.jpg";